module.exports = __webpack_public_path__ + "img/unavailable_statistics.2a92ad8d.svg";